<div class="padding-20">
    <div>
        <mat-grid-list cols="1" [rowHeight]="rowHeigthAdicao">
            <mat-grid-tile class="mat-grid-tile-height">
                <div>
                    <div class="margin-10">
                        <mat-label class="label-titulo flex-center-if-mobile">Adicionar Consulta</mat-label>
                    </div>
                    <div>
                        <mat-card appearance="outlined" [formGroup]="formConsultaGravar" >
                            <mat-card-content class="mat-card-content" >
                                <app-consulta-customizada #consultaFilial matInput formControlName="cdFilial" class="form-field-material" [labelDaDescricao]="'Filial'" [identificador]="'cntFilial'"
                                    [campoFiltro]="'CD_FILIAL,NM_FILIAL'" [lookupExibicao]="['CD_FILIAL', 'NM_FILIAL']"
                                    complementoConsulta=""  
                                    (itemCosulta)="receberItemConsultaFilial($event)" [campoRequerido]="true">
                                </app-consulta-customizada>
                                      
                                <app-consulta-customizada #consultaAcesso matInput formControlName="cdAcesso" class="form-field-material" [labelDaDescricao]="'Ação'" [identificador]="'cntAcessoAcao'"
                                    [campoFiltro]="'CD_ACESSO,NM_ACAO'" [lookupExibicao]="['CD_ACESSO', 'NM_ACAO']" 
                                    complementoConsulta="fl_classificacao in ('R','G','L')" 
                                    (itemCosulta)="receberItemConsultaAcesso($event)" [campoRequerido]="true" >
                                </app-consulta-customizada>
                                <mat-form-field appearance="fill">
                                    <mat-label>Ordem</mat-label>
                                    <input matInput class="input" formControlName="ordem"/>    
                                </mat-form-field>
                                <mat-form-field appearance="fill">
                                    <mat-label>Título da consulta</mat-label>
                                    <input matInput class="input" formControlName="tituloConsulta"/>    
                                </mat-form-field>
                                <div style="width: 100%;">
                                    <mat-form-field appearance="fill" class="campo-descricao">
                                        <mat-label>Descrição</mat-label>
                                        <textarea matInput class="input no-resize" formControlName="descricao"></textarea>  
                                    </mat-form-field>
                                    <mat-checkbox formControlName="ativo" [checked]="formConsultaGravar.get('flAtivo').value" (change)="selecionarAtivo(formConsultaGravar.get('flAtivo').value)">Ativo</mat-checkbox>
                                    <button class="botao-form" mat-flat-button color="primary" style="margin-left: 10px;" (click)="salvar()" >
                                        Salvar
                                    </button>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </mat-grid-tile>
        </mat-grid-list>
        <div *ngIf="consultasGerenciais?.length > 0" class="margin-top-10">
            <div class="margin-10">
                <mat-label class="label-titulo flex-center-if-mobile">Lista de Consultas Gerenciais</mat-label>
            </div>
            <mat-accordion *ngFor="let consulta of consultasGerenciais; let i = index">
                <mat-expansion-panel class="margin-bottom-10"  hideTogle>
                    <mat-expansion-panel-header [ngClass]="isLayoutMobile ? 'height-mobile':'' ">
                        <mat-panel-title>
                            {{consulta.tituloConsulta}}
                        </mat-panel-title>
                        <mat-panel-description>
                            Filial: {{consulta.cdFilial}} | De: {{consulta.dtAtz | date:'dd/MM/yyyy HH:mm:ss'}} | Código de acesso: {{consulta.cdAcesso}} | Ordem: {{consulta.ordem}}
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div>
                        <mat-grid-list cols="1" [rowHeight]="(rowHeigthEdicao)">
                            <mat-grid-tile>
                                <mat-card [appearance]="'raised'" >
                                    <mat-card-content class="mat-card-content" >
                                        <app-consulta-customizada maxInput class="form-field-material" [labelDaDescricao]="'Filial'" [identificador]="'cntFilial'"
                                            [campoFiltro]="'CD_FILIAL,NM_FILIAL'" [campoChaveDoFiltro]="'CD_FILIAL'" [lookupExibicao]="['CD_FILIAL', 'NM_FILIAL']"
                                            [complementoConsulta]="''" [possuiItemInicial]="true" [itemInicial]="consulta.cdFilial" (itemCosulta)="receberItemConsultaFilialEditar($event, consulta)">
                                        </app-consulta-customizada>
                                        <app-consulta-customizada maxInput class="form-field-material" [labelDaDescricao]="'Ação'" [identificador]="'cntAcessoAcao'"
                                                [campoFiltro]="'CD_ACESSO,NM_ACAO'" [campoChaveDoFiltro]="'CD_ACESSO'" [lookupExibicao]="['CD_ACESSO', 'NM_ACAO']"
                                                complementoConsulta="fl_classificacao in ('R','G','L')" [possuiItemInicial]="true" 
                                                [itemInicial]="consulta.cdAcesso"
                                                (itemCosulta)="receberItemConsultaAcessoEditar($event, consulta)">
                                            </app-consulta-customizada>
                                        <mat-form-field appearance="fill">
                                            <mat-label>Ordem</mat-label>
                                            <input matInput class="input" [(ngModel)]="consulta.ordem"/>    
                                        </mat-form-field>
                                        <mat-form-field appearance="fill">
                                            <mat-label>Título da consulta</mat-label>
                                            <input matInput class="input" [(ngModel)]="consulta.tituloConsulta" />    
                                        </mat-form-field>
                                        <div style="width: 100%;">
                                            <mat-form-field appearance="fill" class="campo-descricao">
                                                <mat-label>Descrição</mat-label>
                                                <textarea matInput class="input no-resize" [(ngModel)]="consulta.descricao"></textarea>  
                                            </mat-form-field>
                                            <mat-checkbox 
                                                formControlName="flAtivo"
                                                [checked]="consulta.form.value.flAtivo"
                                                (change)="selecionarAtivoEdicao(consulta)">Ativo
                                            </mat-checkbox>
                                            <button class="botao-editar-form" mat-flat-button color="primary" style="margin-left: 10px;" (click)="editar(consulta)">
                                                Editar
                                            </button>
                                            <button class="botao-editar-form" mat-flat-button color="warn" style="margin-left: 10px;" (click)="excluir(consulta)">
                                                Excluir
                                            </button>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </mat-grid-tile>
                        </mat-grid-list>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</div>
<app-rodape></app-rodape>
